import { Navigate, Outlet } from "react-router-dom";

import { Box } from "@mui/material";

import { useState } from "react";

import { classNames } from "@/utils/classNames";

import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { useIsFeatureActiveUnauthenticated } from "@/utils/useIsFeatureActiveUnauthenticated";
import { useOnboardingRedirectPath } from "@/utils/useOnboardingVariant";

import { Loader } from "@/components/Loader/Loader";

import { NotificationPanel } from "@/pages/Private/pages/Notifications/components/NotificationPanel";
import { NotificationToast } from "@/pages/Private/pages/Notifications/components/NotificationToast";

import { OnboardingTour } from "@/components/FeatureOnboarding/OnboardingTour";
import { OnboardingTourHost } from "@/pages/Private/pages/OnboardingTour/OnboardingTourHost";

import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";

import { Sidebar } from "../Sidebar/Sidebar";
import { useTopbarInfo } from "../Topbar/useTopbarInfo";

export const MainLayout = () => {
	const initialUser = localStorage.getItem("initialUser");

	const [enabled, setEnabled] = useState<boolean>(false);

	const SELF_REGISTER = useIsFeatureActiveUnauthenticated(FeaturesCodes.SELF_REGISTER);

	// Which onboarding still owes this user, derived once server-side (PREC-3719).
	const onboardingRedirect = useOnboardingRedirectPath();

	if (SELF_REGISTER === undefined) {
		return <Loader />;
	}

	if (onboardingRedirect) {
		return <Navigate to={onboardingRedirect} />;
	}

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "100vh",
			}}
		>
			<>
				<div
					className={classNames(
						"w-full flex flex-row h-[100vh]",
						initialUser ? "bg-other-org" : "bg-brand-white"
					)}
				>
					<Sidebar />
					<div className="sm:z-10 flex-grow min-w-0 h-full relative">
						<div
							className={classNames(
								"bg-white px-4 pt-3 overflow-y-visible overflow-x-auto lg:overflow-auto pb-4",
								"h-[calc(100%-1rem)] max-h-[calc(100vh-1rem)]"
							)}
							id="outlet-container"
							// scrollbarGutter keeps the scrollbar's space reserved so the page (and the top
							// nav) doesn't shift horizontally when content height toggles the scrollbar (PREC-3502).
							style={{ scrollbarWidth: "none", msOverflowStyle: "none", scrollbarGutter: "stable" }}
						>
							<ErrorBoundary>
								<Outlet />
							</ErrorBoundary>
						</div>
					</div>
				</div>
				<NotificationPanel />
				<NotificationToast />
				<OnboardingTour />
				<OnboardingTourHost />
			</>
		</Box>
	);
};
